module.exports = __webpack_public_path__ + "img/featuredartist (7).0879f9fc.jpg";